import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import TripsList from './TripsList.jsx';
import { useSetModalTitle } from '../../../hooks/modal/useSetModalTitle.ts';

interface TripsRouteProps { };

export const TripsRoute: React.FC<TripsRouteProps> = () => {
  useSetModalTitle('Trips');

  // Get the device filter from the URL query string
  const location = useLocation();

  const deviceFilter = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const deviceFilterString = queryParams.get('device-filter');
    return deviceFilterString ? deviceFilterString.split(',') : null;
  }, [location.search]);

  return <TripsList deviceFilter={deviceFilter} />;
};